import './flash.css'

function rand(len) {
  return window.crypto.getRandomValues(new Uint32Array(1))[0] % len
}

function convert(value, radix) {
  const size = 10
  const factor = BigInt(radix ** size)
  let i = value.length % size || size
  const parts = [value.slice(0, i)]

  while (i < value.length) {
    parts.push(value.slice(i, i + size))
    i += size
  }

  return parts.reduce((r, v) => r * factor + BigInt(Number.parseInt(v, radix)), BigInt(0))
}

function flash(designs) {
  const [size, num] = designs[rand(designs.length)].split(',')
  const sizeNum = Number.parseInt(size, 10)
  const totalCells = sizeNum * sizeNum

  document.body.setAttribute(
    'style',
    `grid: repeat(${size}, ${100 / sizeNum}vw) / repeat(${size}, ${100 / sizeNum}vw);`,
  )

  convert(num, 36)
    .toString(2)
    .padStart(totalCells, '0')
    .split('')
    .forEach((n) => {
      const k = document.createElement('wka')
      k.setAttribute(n === '1' ? 'l' : 'O', '')
      document.body.appendChild(k)
    })
  const crew = document.querySelectorAll('wka')
  function flash() {
    const y = crew[Math.floor(Math.random() * crew.length)]
    y.classList.toggle(['o', 'p'][Math.floor(Math.random() * 2)])
  }
  function forever() {
    setTimeout(forever, Math.random() * 50 + 50)
    flash()
  }
  return forever
}
fetch('grid.txt')
  .then((res) => {
    if (res.ok) {
      return res.text()
    }
    throw 'No'
  })
  .then((texts) => {
    return flash(texts.split('\n'))
  })
  .then((result) => result())
